import React from "react";
import IconTxtBtnArrow from '../../../../../img/icon-txt-btn-arrow.svg';
import IconUnlocked from '../../../../../img/icon-unlocked.svg';
import IconLocked from '../../../../../img/icon-locked.svg';
import PlayButton from '../../../../../img/button-play-circle.svg';
import { getFormattedDate } from '../helpers/formattedDate';
import ProgressBar from './progressBar';
import LoadingPanel from './loadingPanel';
import AudioPageLink from './audioPageLink';

// import api
import { useLazyRegisterOnlineCourseQuery } from '../api/courses';


/**
 * Current courses component
 * @param {Object} currentCourse - The current online course
 */
function CurrentOnlineCourse({currentCourse, brightspaceBaseUrl, activeCourseName}) {

    const productPermalinkOverride = activeCourseName + "/";

    const brightspaceCourseLink = brightspaceBaseUrl + '/' + currentCourse?.currentModulePost?.brightspace_course_id;

    const currentModuleCompleted = currentCourse?.currentModuleCompleted;
    const totalOnlineCourseModules = currentCourse?.totalOnlineCourseModules;

    const nextModuleIsActive = currentCourse?.nextOnlineCourseModule?.IsActive;

    const courseExpired = (currentCourse?.CourseExpirationDate * 1000) < new Date();

    const nextModuleReleaseDate = currentCourse?.nextOnlineCourseModule?.ReleaseDate;

    // register user for the online course
    const [registerUser, {isLoading: registrationIsLoading, currentData: registrationCurrentData}] = useLazyRegisterOnlineCourseQuery();

        /**
     * Register the user for the online course
     * @param {number} moduleWPPostID - The first module WP Post ID
     * @returns void
    */
        const registerClickHandler = (onlineCourseWPPostId, productPermalinkOverride) => {
            registerUser({onlineCourseWPPostId, productPermalinkOverride});
        }

    // after the user clicks to register and we get a response, if it was successful
    // we want to redirect to the cart page
    if(registrationCurrentData?.success && registrationCurrentData?.redirect_url){
        window.location.href = registrationCurrentData?.redirect_url;
    }

    const getLockIcon = () => {
        if(currentModuleCompleted){
            return (
                <p><IconLocked/></p>
            )
        } else {
            return (
                <p><IconUnlocked/></p>
            )
        }
    }

    const handlePlayButtonClick = (e) => {
        e.preventDefault();
        if (courseExpired) {
            return;
        } else if (currentModuleCompleted) {
            registerClickHandler(currentCourse.nextModuleWPPostID, productPermalinkOverride);
        } else {
            window.open(brightspaceCourseLink, '_blank');
        }
    }

    const getModuleLink = () => {
        if(registrationIsLoading || (registrationCurrentData?.success && registrationCurrentData?.redirect_url)){
            return (
                <LoadingPanel loadText={'Adding to cart'}/>
            )
        } else if (courseExpired) {
            // if the course has expired
            return (
                <p><b>Your course has expired, please contact the Kois Center to continue your journey.</b></p>
            )
        } else if(currentModuleCompleted){
            // if the module is complete but the next module is not active show the date it will be available
            if(!nextModuleIsActive){
                // if we have a realease date display it
                // if(nextModuleReleaseDate){
                //     return (
                //         <p><b>Coming soon {getFormattedDate(nextModuleReleaseDate)}</b></p>
                //     )
                // } else {
                    return  (
                        <p><b>Coming soon!</b></p>
                    )
                // }
            }
            // if the module is complete and there is a next module, show the register button
            return (
                <a className="course--link btn c-btn--light"  href="javascript:void(0);" onClick={()=>registerClickHandler(currentCourse.nextModuleWPPostID, productPermalinkOverride)} >Add Next Module</a>
            )
        // if they have NOT completed the current module
        } else {
            return (
                <a className="course--link btn c-btn--light"  href={brightspaceCourseLink} target="_blank">Resume Progress</a>
            )
        }
    }

    const getModuleCount = () => {
        if(currentModuleCompleted){
            return (
                <>
                    {`${parseInt(currentCourse.currentModuleNumber) + 1} of ${totalOnlineCourseModules}`}
                </>
            )
        } else {
            return (
                <>
                    {`${currentCourse.currentModuleNumber} of ${totalOnlineCourseModules}`}
                </>
            )
        }
    }

    const getProgressBar = () => {
        let completed = currentCourse.currentModuleNumber;
        if(!currentModuleCompleted){
            completed = parseInt(completed) - 1;
        }

        return (
            <ProgressBar label={`Completed module: ${completed} of ${totalOnlineCourseModules}`} progress={completed} total={totalOnlineCourseModules}/>
        )

    }

    const getTitleAndDescription = () => {
        if(currentModuleCompleted){
            return (
                <>
                    <h5 dangerouslySetInnerHTML={{__html: currentCourse.nextModulePost.post_title}}></h5>
                    <p dangerouslySetInnerHTML={{__html: currentCourse.nextModulePost.post_content}}></p>
                </>
            )
        } else {
            return (
                <>
                    <h5 dangerouslySetInnerHTML={{__html: currentCourse.currentModulePost.post_title}}></h5>
                    <p dangerouslySetInnerHTML={{__html: currentCourse.currentModulePost.post_content}}></p>
                </>
            )
        }
    }

    return (
        <>
            <div className="table-course-list__row responsive-grid rg-align-items-center">
                <div className="rg-5 rg-sm-12 rg-xs-12">
                    <h4 className={`cell-headline${courseExpired ? ' red-alert': ''}`}>{`Expire${courseExpired ? 'd' :'s'}`} {getFormattedDate(currentCourse.CourseExpirationDate)}</h4>
                    Registered as Participant
                </div>
                <div className="rg-3 rg-sm-12 rg-xs-12">
                    <h5 className="digital-option"><span className="play-button"><PlayButton/></span>Digital Course</h5>
                </div>
                {/* If we want to add the ability for the user to cancel on the front end in the future */}
                {/* <div className="rg-4 rg-sm-12 rg-xs-12">
                    <a className="text-btn-arrow"  href="">Cancel Registration<span className="link-arrow"><IconTxtBtnArrow/></span></a>
                </div> */}

                <div className="current-online-course-details-container">
                    <h5>Next Up</h5>
                    <div className="current-online-course-details responsive-grid">
                        <div className="image-container rg-2 rg-md-4 rg-mdl-4 rg-sm-12 rg-xs-12">
                            <div className="play">
                                <img src={ currentCourse?.image[0] }/>
                                <span className="play-btn play-btn--link" onClick={handlePlayButtonClick}><PlayButton/></span>
                            </div>
                        </div>
                        
                        <div className="details-container rg-8 rg-sm-12 rg-xs-12">
                            {getTitleAndDescription()}
                            <div className="module-links-container">
                            {getModuleLink()}
                            {(!registrationIsLoading && currentCourse?.audioFilesPage && (!registrationCurrentData?.success || !registrationCurrentData?.redirect_url)) &&
                                <AudioPageLink url={currentCourse?.audioFilesPage}/>
                            }
                            </div>
                        </div>

                        <div className="locked-and-modules rg-2 rg-md-12 rg-mdl-12 rg-sm-12 rg-xs-12 responsive-grid">
                            <div className="locked-status rg-md-6 rg-mdl-6">
                                {getLockIcon()}
                            </div>
                            <h5 className='module-count rg-12 rg-md-6 rg-mdl-6'>
                                {getModuleCount()}
                            </h5>
                        </div>

                    </div>
                </div>
                {/* Progress Bar */}
                {getProgressBar()}
            </div>
        </>
    );
}

export default CurrentOnlineCourse;